// extracted by mini-css-extract-plugin
export var modal = "_ez-0";